import { z } from 'zod';
/**
 * Contratos públicos de la cola.
 *
 * Viven en `@gc/shared` y no en `@gc/jobs` porque la interfaz los necesita y
 * `apps/web` solo puede depender de los contratos públicos
 * (docs/02_ARCHITECTURE.md). El guardarraíl de ESLint lo impone.
 */
/** Tipos de job. GENERATE_VIDEO queda reservado al futuro. */
export const jobTypeSchema = z.enum([
    'GENERATE_TEXT',
    'GENERATE_IMAGE',
    'GENERATE_MUSIC',
    'GENERATE_VOICE',
    'GENERATE_VIDEO',
    'POLL_GENERATION',
    'RENDER_PROJECT',
]);
export const jobStatusSchema = z.enum([
    'PENDING',
    'RUNNING',
    'COMPLETED',
    'FAILED',
    'CANCELLED',
]);
/** Estados terminales: un job así no se vuelve a ejecutar. */
export const TERMINAL_JOB_STATUSES = ['COMPLETED', 'FAILED', 'CANCELLED'];
export function esJobTerminal(status) {
    return TERMINAL_JOB_STATUSES.includes(status);
}
/** DTO público de job. Nunca incluye credenciales ni respuesta remota cruda. */
export const jobDtoSchema = z.object({
    id: z.uuid(),
    projectId: z.uuid(),
    type: jobTypeSchema,
    status: jobStatusSchema,
    progress: z.number().int().min(0).max(100),
    attemptCount: z.number().int(),
    maxAttempts: z.number().int(),
    sceneId: z.uuid().nullable(),
    generationId: z.uuid().nullable(),
    workflowRunId: z.uuid().nullable(),
    cancellationRequestedAt: z.iso.datetime().nullable(),
    /** Error ya normalizado: categoría y mensaje, sin stack. */
    error: z
        .object({
        kind: z.string(),
        message: z.string(),
        retryable: z.boolean().optional(),
        possiblyBilled: z.boolean().optional(),
        requiresReview: z.boolean().optional(),
    })
        .nullable(),
    createdAt: z.iso.datetime(),
    startedAt: z.iso.datetime().nullable(),
    completedAt: z.iso.datetime().nullable(),
});
//# sourceMappingURL=jobs.js.map